import { Card, Container } from "react-bootstrap";

export default function Projects() {
  return (
    <section className="py-5 bg-white">
      <Container>
        <h2 className="text-center text-primary fw-bold">Ongoing Projects</h2>
        <p className="text-center text-secondary mt-3 mx-auto" style={{ maxWidth: "800px" }}>
          Explore our current construction projects that are transforming skylines and enhancing infrastructure.
        </p>

        <div className="mt-5 mx-auto" style={{ maxWidth: "900px" }}>
          {/* Anti Erosion Bunds */}
          <Card className="border-0 p-4 mb-4"  style={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05), 0px -2px 8px rgba(0, 0, 0, 0.03)", borderRadius: "12px" }}>
            <h3 className="text-primary fw-bold">Anti Erosion Bunds</h3>
            <p className="text-secondary mt-2">
              A project focused on constructing erosion control bunds to prevent soil erosion and protect agricultural land in coastal and riverbank areas.
            </p>
          </Card>

          {/* Bridge Construction */}
          <Card className="border-0 p-4 mb-4"  style={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05), 0px -2px 8px rgba(0, 0, 0, 0.03)", borderRadius: "12px" }}>
            <h3 className="text-primary fw-bold">Bridge Construction</h3>
            <p className="text-secondary mt-2">
              Developing durable and efficient bridge structures to improve transportation and connectivity in both urban and rural areas.
            </p>
          </Card>

          {/* Shelter Homes */}
          <Card className="border-0 p-4 mb-4"  style={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05), 0px -2px 8px rgba(0, 0, 0, 0.03)", borderRadius: "12px" }}>
          <h3 className="text-primary fw-bold">Shelter Homes</h3>
            <p className="text-secondary mt-2">
              Building safe and sustainable shelter homes for vulnerable communities, offering security and essential amenities.
            </p>
          </Card>
        </div>
      </Container>
    </section>
  );
}
